'use strict';

const decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// ./~/asn1.js/lib/asn1/decoders/index.js
// module id = 92
// module chunks = 0